export const WELCOME_TOUR_COMPLETED_KEY = 'sf-welcome-tour-completed';
